import { render, staticRenderFns } from "./TheStatementCreation.vue?vue&type=template&id=4796ace4&"
import script from "./TheStatementCreation.vue?vue&type=script&lang=js&"
export * from "./TheStatementCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports